import { InputHTMLAttributes } from 'react';
import { Field } from 'react-final-form';

export interface TextAreaFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string,
  placeholder?: string,
  labelClassName?: string,
  rows?: number
  textAreaClassName?: string
  resizeable?: boolean
  name?: string
}

const TextArea = ({
  label,
  labelClassName,
  placeholder,
  rows = 4,
  textAreaClassName,
  resizeable = true,
  name,
}: TextAreaFieldProps) => {
  const labelDefaultClassName = "text-text-color-high-em"
  const textAreaDefaultClassName = "w-full mt-1 rounded-lg border-[#D0D5DD]"
  return (
    <Field name={name}>
      {({ input, meta }) => (
        <div className='space-y-2'>
          <p className={labelClassName ? labelClassName : labelDefaultClassName}>{label}</p>
          <textarea
            className={textAreaClassName ? textAreaClassName : textAreaDefaultClassName}
            rows={rows}
            placeholder={placeholder}
            style={{ resize: resizeable ? 'both' : 'none' }}
            {...input}
          />
        </div>
      )}
    </Field>
  )
}

export default TextArea